export const getConfiguredStatusName = (statuses, target) => {
  const status = (Array.isArray(statuses) ? statuses : [])
    .find(item => String(item.id) === String(target));
  return status?.name || target || '';
};

export const buildTransitionStatusOptions = (statuses, currentTarget = '') => {
  const source = Array.isArray(statuses) ? statuses : [];
  const nameCounts = source.reduce((counts, status) => {
    const name = status?.name || '';
    counts[name] = (counts[name] || 0) + 1;
    return counts;
  }, {});

  const options = source.map(status => ({
    value: String(status.id),
    label: nameCounts[status.name] > 1
      ? `${status.name} (ID: ${status.id})`
      : status.name
  }));

  const normalizedTarget = String(currentTarget || '');
  if (
    normalizedTarget
    && !options.some(option => option.value === normalizedTarget)
  ) {
    options.push({ value: normalizedTarget, label: normalizedTarget });
  }

  return options;
};
